// src/config/firebaseClient.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCtk3lYZpFhxrHT094A1oh72x3QHBgGD0FI",
  authDomain: "cashbet-e2a20.firebaseapp.com",
  databaseURL: "https://cashbet-e2a20-default-rtdb.firebaseio.com",
  projectId: "cashbet-e2a20",
  storageBucket: "cashbet-e2a20.appspot.com",
  messagingSenderId: "468596246489",
  appId: "1:468596246489:web:901bf7ea7fa4b67ed67bc8",
  measurementId: "G-PXCF16MBW4"
};

// 🛡️ Garante que o app só será inicializado uma vez
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const database = getDatabase(app);

export { database };
